// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","by":"footer-module--by--34cKy","info":"footer-module--info--3ISzk"};